// Custom Variant Dropdown
function initCustomDropdown(dropdown) {
  const header = dropdown.querySelector('[data-dropdown-header]');
  const menu = dropdown.querySelector('[data-dropdown-menu]');
  
  if (!header || !menu) return;
  
  const newHeader = header.cloneNode(true);
  header.parentNode.replaceChild(newHeader, header);
  
  newHeader.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    document.querySelectorAll('[data-custom-dropdown]').forEach(otherDropdown => {
      if (otherDropdown !== dropdown) {
        otherDropdown.classList.remove('is-open');
      }
    });
    
    dropdown.classList.toggle('is-open');
  });
  
  const options = menu.querySelectorAll('.dropdown-option');
  
  options.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const clickedValue = option.getAttribute('data-option-value');
      const position = option.getAttribute('data-option-position');
      const isOutOfStock = option.classList.contains('out-of-stock');
      
      const fieldset = dropdown.closest('fieldset');
      const select = fieldset ? fieldset.querySelector(`[data-variant-select-${position}]`) : dropdown.querySelector(`[data-variant-select-${position}]`);
      
      if (select) {
        select.value = clickedValue;
        const event = new Event('change', { bubbles: true });
        select.dispatchEvent(event);
      }
      
      const radioInputs = fieldset ? fieldset.querySelectorAll('.hidden-variant-radio') : [];
      radioInputs.forEach(radio => {
        if (radio.value === clickedValue) {
          radio.checked = true;
          const radioEvent = new Event('change', { bubbles: true });
          radio.dispatchEvent(radioEvent);
        } else {
          radio.checked = false;
        }
      });
      
      const displayText = fieldset ? fieldset.querySelector(`[data-selected-value-${position}]`) : dropdown.querySelector(`[data-selected-value-${position}]`);
      if (displayText) {
        displayText.textContent = clickedValue;
      }
      
      menu.querySelectorAll('.dropdown-option').forEach(opt => {
        opt.classList.remove('active');
        const checkmark = opt.querySelector('.option-checkmark');
        if (checkmark) {
          checkmark.remove();
        }
      });
      
      option.classList.add('active');
      const checkmark = document.createElement('span');
      checkmark.className = 'option-checkmark';
      checkmark.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8L6.5 11.5L13 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      option.appendChild(checkmark);
      
      dropdown.classList.remove('is-open');
    });
  });
}

// Variant Buttons
function initVariantButtons() {
  const buttonContainers = document.querySelectorAll('[data-variant-buttons]');
  
  buttonContainers.forEach(container => {
    const buttons = container.querySelectorAll('.hp-variant-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (button.disabled || button.classList.contains('out-of-stock')) {
          return;
        }
        
        const clickedValue = button.getAttribute('data-option-value');
        const position = button.getAttribute('data-option-position');
        
        const fieldset = button.closest('fieldset');
        const select = fieldset ? fieldset.querySelector(`[data-variant-select-${position}]`) : null;
        
        if (select) {
          select.value = clickedValue;
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
        }
        
        const radioInputs = fieldset ? fieldset.querySelectorAll('.hidden-variant-radio') : [];
        radioInputs.forEach(radio => {
          if (radio.value === clickedValue) {
            radio.checked = true;
            const radioEvent = new Event('change', { bubbles: true });
            radio.dispatchEvent(radioEvent);
          } else {
            radio.checked = false;
          }
        });
        
        const displayText = fieldset ? fieldset.querySelector(`[data-selected-value-${position}]`) : null;
        if (displayText) {
          displayText.textContent = clickedValue;
        }
        
        buttons.forEach(btn => {
          btn.classList.remove('active');
        });
        
        button.classList.add('active');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('[data-custom-dropdown]');
  
  dropdowns.forEach(dropdown => {
    initCustomDropdown(dropdown);
  });
  
  initVariantButtons();
  
  document.addEventListener('click', (e) => {
    dropdowns.forEach(dropdown => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('is-open');
      }
    });
  });
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('is-open');
      });
    }
  });
});

if (document.readyState === 'loading') {
} else {
  setTimeout(() => {
    const dropdowns = document.querySelectorAll('[data-custom-dropdown]');
    dropdowns.forEach(dropdown => {
      initCustomDropdown(dropdown);
    });
    initVariantButtons();
  }, 100);
}


